import { render, staticRenderFns } from "./SoccerChalkboard.vue?vue&type=template&id=58dc1777&scoped=true&"
import script from "./SoccerChalkboard.vue?vue&type=script&lang=js&"
export * from "./SoccerChalkboard.vue?vue&type=script&lang=js&"
import style0 from "./SoccerChalkboard.vue?vue&type=style&index=0&id=58dc1777&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc1777",
  null
  
)

export default component.exports